import React from 'react';
import PropTypes from 'prop-types';

// Labelled multi-select checkbox group used by the generation-config
// sub-conditions and the custom-rule editor. Empty selection = no constraint
// on that attribute.
function CheckboxGroup({ label, options, selected, onChange, disabled }) {
  const toggle = (value) => {
    if (selected.includes(value)) onChange(selected.filter((v) => v !== value));
    else onChange([...selected, value]);
  };
  return (
    <div>
      <div className="text-xs font-semibold mb-1" style={{ color: 'var(--text-muted)' }}>
        {label}
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1">
        {options.map((o) => (
          <label
            key={o.value}
            className="inline-flex items-center gap-1.5 text-xs cursor-pointer select-none"
            style={{ color: 'var(--text-primary)', marginBottom: 0 }}
          >
            <input
              type="checkbox"
              checked={selected.includes(o.value)}
              onChange={() => toggle(o.value)}
              disabled={disabled}
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
            />
            {o.label}
          </label>
        ))}
      </div>
    </div>
  );
}

CheckboxGroup.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }))
    .isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

CheckboxGroup.defaultProps = {
  disabled: false
};

export default CheckboxGroup;
